import { SimpleToggle } from "components/Form/components/Switch/Switch";
import Tooltip from "components/Tooltip/Tooltip";
import "./ChildrenScopeToggle.scss";

export interface ChildrenScopeToggleProps {
    showAllDescendants: boolean;
    setShowAllDescendants: (showAllDescendants: boolean) => void;
}

/**
 * Toggle for the execution "Children" tab: switch between showing the full set of
 * dependency descendants (default — matches the dependency visualization) and only
 * the direct child executions. Styled like the execution-list "Top-level executions
 * only" switch.
 */
export const ChildrenScopeToggle = ({
    showAllDescendants,
    setShowAllDescendants,
}: ChildrenScopeToggleProps) => (
    <Tooltip overlay="Show the full set of descendant executions (matching the dependency visualization) instead of only the direct children">
        <div className="childrenScopeToggle">
            <SimpleToggle
                identifier="children_show_all_descendants"
                size="md"
                value={showAllDescendants}
                additionalAttributes={{
                    onChange: (checked: boolean) => setShowAllDescendants(checked),
                }}
            />
            <span
                className="childrenScopeToggle__label"
                onClick={() => setShowAllDescendants(!showAllDescendants)}
            >
                All descendants
            </span>
        </div>
    </Tooltip>
);
